<!-- Start: Rejwan: 09-02-2026 Front Routes -->
<template>
    <div>


    <div class="col-md-12">
       
        <b-overlay :show="showoverlay_h" rounded="sm" class="no-shadow trz_overlay">
            <template v-if="statememt_available">
            <b-form @submit.stop.prevent="onSubmit">
              

                <!-- <b-form-group id="profit_fiscal_year-group" class="required-field" label-for="profit_fiscal_year" label="Fiscal Year" v-show="profit_distribution_type=='16' "> -->
                <b-form-group id="profit_fiscal_year-group" class="required-field" label-for="profit_fiscal_year" label="Fiscal Year" v-show="profit_distribution_type=='19' "> <!-- Rejwan: 23-06-2026 -->
                  
                    <!-- <b-form-select id="profit_fiscal_year" v-model="profit_fiscal_year"  
                    name="profit_fiscal_year" v-validate="{ required: true}" :state="validateState('profit_fiscal_year')"   
                    aria-describedby="profit_fiscal_year-feedback" data-vv-as="Fiscal Year" data-vv-validate-on="none" 
                    :disabled="profit_distribution_type != '16' && profit_distribution_type !='4'"> --> <!-- Rejwan: 23-06-2026 -->
                    <b-form-select id="profit_fiscal_year" v-model="profit_fiscal_year"  
                    name="profit_fiscal_year" v-validate="{ required: true}" :state="validateState('profit_fiscal_year')"   
                    aria-describedby="profit_fiscal_year-feedback" data-vv-as="Fiscal Year" data-vv-validate-on="none" 
                    :disabled="profit_distribution_type != '19' && profit_distribution_type !='4'"> <!-- Rejwan: 23-06-2026 -->
                        <b-form-select-option value="">Please Select ...</b-form-select-option>
                        <template v-if="pf_settings.pf_year_end.opt_value != 12"> 
                            <option v-for='pyr in f_y'   :value='pyr'>{{ pyr }}</option>		
                        </template>	
                        <template v-else>
                            <option v-for='pyr in years'  :value='pyr'>{{ pyr }}</option>		
                        </template>		
                    </b-form-select>

                    <b-form-invalid-feedback id="profit_fiscal_year-feedback">{{ veeErrors.first('profit_fiscal_year') }}</b-form-invalid-feedback>
                </b-form-group>

                <div class="full-width text-center"> <!-- Mustafijur: 23-08-2026 -->
                <b-button class = "mt-1" type="submit"  variant="primary">Download</b-button>
                </div>
            </b-form>
            </template>
            <template v-else>
                <div class="row no-gutters py-2 mb-3 border-bottom ml-3">
                    <div class="col-sm-12 pr-3 ">
                        No Contribution available to generate statement.
                    </div>
                </div>
            </template>
            
          
        </b-overlay>
    </div>
</div>
</template>

<script>
    export default{
        
        mounted() {
        },
        props: ['employee_id','pageurl','store_scope'], 
        data(){            
           
            return {      
                
                loader:false,       
                showoverlay : true,
                showoverlay_h : false,
                statememt_available: true,
                disableme : false,
                e_id:this.employee_id,
                show_waiver_revive : false,
                fdata : {profit_waiver_from:null,profit_revive_from:null,employee_id:this.employee_id,store_scope:this.store_scope},
                respData:[],
                // profit_distribution_type:16, // Rejwan: 23-06-2026
                profit_distribution_type:19, // Rejwan: 23-06-2026
                profit_distribution_type_options:[
                    { value: null, text: "Please Select ..." },
                    // Start: Rejwan: 23-06-2026
                    // { value: "16", text: "Fiscal Year" },
                    // { value: "15", text: "Month Range" },
                    { value: "17", text: "Fiscal Year" },
                    { value: "18", text: "Month Range" },
                    // End: Rejwan: 23-06-2026
                ],
                
                profit_specific_range_from_year:'',
                profit_specific_range_from_month:'',
                profit_specific_range_to_year:'',
                profit_specific_range_to_month:'',
                profit_fiscal_year:'',
                f_y:[],
                modification_flag:0,
                selected:[],
                years:[],
                pf_settings :{pf_profit_waive_feature:{ opt_value: 0, status: 0 },pf_year_end:{ opt_value: 0, status: 0 },},
                months: [
                    { value: 1, text: "January" },
                    { value: 2, text: "February" },
                    { value: 3, text: "March" },
                    { value: 4, text: "April" },
                    { value: 5, text: "May" },
                    { value: 6, text: "June" },
                    { value: 7, text: "July" },
                    { value: 8, text: "August" },
                    { value: 9, text: "September" },
                    { value: 10, text: "October" },
                    { value: 11, text: "November" },
                    { value: 12, text: "December" },
                ],
                f_y_months: [
                   
                    { value: 7, text: "July" },
                    { value: 8, text: "August" },
                    { value: 9, text: "September" },
                    { value: 10, text: "October" },
                    { value: 11, text: "November" },
                    { value: 12, text: "December" },
                    { value: 1, text: "January" },
                    { value: 2, text: "February" },
                    { value: 3, text: "March" },
                    { value: 4, text: "April" },
                    { value: 5, text: "May" },
                    { value: 6, text: "June" },
                    
                ],
                

            }
        },
        
        methods:{

            resetForm()
            {    
                
                this.fdata = {profit_waiver_from:null,profit_revive_from:null,employee_id:this.employee_id,store_scope:this.store_scope};
                this.$nextTick(() => {
                    this.$validator.reset();
                });

            }, 
            getFromMonthKey: function(month,f_y_months)
            {
                let f = Object.keys(f_y_months).filter(key => f_y_months[key].value === month);
              
                return f[0];
                
            },
            getPFSettings: function()
            { 
                
                let currentObj = this;
                // axios.get(this.$api_url+'/pf/settings').then(function (response) { // Start: Rejwan: 09-02-2026 Front Routes
                axios.get(this.$api_url_front+'/pf/settings').then(function (response) { // Start: Rejwan: 09-02-2026 Front Routes
                    currentObj.pf_settings = response.data.data;
                   
                        
                })  
                .catch(function (error) {
                console.log(error);
                });
                
            },
            validateState(ref)
            {
                if ( this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated) )
                {

                    return !this.veeErrors.has(ref);
                }
                return null;
            },
            downloadCertificate(id,mod_flag,flag = 0 , file_only = 1)
            {
              
                this.selected = [];
                this.showoverlay_h = true;
                this.modification_flag = mod_flag;
                this.selected.push(id);

                    
                let currentObj = this;
                const config = {
                    headers: { 'content-type': 'multipart/form-data' }
                }
                let from_m = this.profit_specific_range_from_month;
                let to_m = this.profit_specific_range_to_month;
                let formData = new FormData();
                // formData.append('employee_ids', this.selected); // Start: Rejwan: 17-02-2026 Front Routes
                // formData.append('employee_id', this.selected); // Start: Rejwan: 17-02-2026 Front Routes
                formData.append('modification_flag', this.modification_flag);
                formData.append('from_month', from_m);
                formData.append('to_month', to_m); 
                formData.append('flag', flag);
                formData.append('file_only', file_only);
                console.log(file_only);
                var modification_flag =this.modification_flag;

                // if(modification_flag == 16) // Rejwan: 23-06-2026
                if(modification_flag == 19) // Rejwan: 23-06-2026
                {
                    formData.append('fiscal_year', this.profit_fiscal_year); 
                }
                else
                {
                    formData.append('fiscal_year', this.profit_specific_range_from_year);
                }

                currentObj.download_loader = true;

                if(flag == 1 && file_only == 1)
                {
                    currentObj.download_text = 'We are processing the files and this may take some time based on the number of employees selected.';                    

                    // axios.post(this.$api_url+'/templates/downloadmultipletemplate', formData, config) // Start: Rejwan: 15-02-2026 Front Routes
                    axios.post(this.$api_url_front+'/templates/downloadsingletemplate', formData, config) // Start: Rejwan: 15-02-2026 Front Routes
                    .then(function (response) {                            
                                                
                            currentObj.showoverlay_h = false;
                            if(response.data.errors)
                            {                                    
                                var errors = response.data.errors;
                                errors.replace("<br>", "</br>");
                                currentObj.$bvToast.toast(response.data.errors, {title: 'Error!',variant: 'danger',solid: true, toaster: "toaster: b-toaster-top-right"});

                            }

                            else
                            {
                                currentObj.$bvToast.toast('Saved!', {
                                    title: `Success`,
                                    variant: 'success',
                                    solid: true
                                });
                            }
                            
                            currentObj.download_loader = false;  
                            currentObj.download_text = ''; 
                            
                        })
                        .catch(function (error) {
                            currentObj.output = error;
                            currentObj.download_loader = false;
                            currentObj.showoverlay_h = false;
                            
                            currentObj.download_text = '';
                        });
                }
                else
                {
                    // Start: Rejwan: 23-06-2026
                    // currentObj.download_text = 'We are processing your download and this may take some time based on the number of files you are downloading. Do not close this window until the download begins.';                    
                    
                    // // axios.post(this.$api_url+'/templates/downloadmultipletemplate', formData, config) // Start: Rejwan: 15-02-2026 Front Routes
                    // axios.post(this.$api_url_front+'/templates/downloadsingletemplate', formData, {
                    //     ...config,
                    //     responseType: 'blob'  // ADD THIS
                    // }) // Start: Rejwan: 15-02-2026 Front Routes
                    // .then(function (response) {
                        
                    //     currentObj.showoverlay_h = false;
                        
                    //     // Check if response is JSON (means there's an error)
                    //     const contentType = response.headers['content-type'];
                    //     if(contentType && contentType.includes('application/json')){
                    //         const reader = new FileReader();
                    //         reader.onload = function() {
                    //             const data = JSON.parse(reader.result);
                    //             if(data.errors){
                    //                 currentObj.$bvToast.toast(data.errors, {title: 'Error!', variant: 'danger', solid: true});
                    //             }
                    //         };
                    //         reader.readAsText(response.data);
                    //     } else {
                    //         // Trigger file download
                    //         const contentDisposition = response.headers['content-disposition'];
                    //         let fileName = 'download.pdf';
                    //         if(contentDisposition){
                    //             const match = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
                    //             if(match) fileName = match[1].replace(/['"]/g, '');
                    //         }
                    //         const url = window.URL.createObjectURL(new Blob([response.data]));
                    //         const link = document.createElement('a');
                    //         link.href = url;
                    //         link.setAttribute('download', fileName);
                    //         document.body.appendChild(link);
                    //         link.click();
                    //         link.remove();
                    //         window.URL.revokeObjectURL(url);
                    //     }

                    //     currentObj.download_loader = false;  
                    //     currentObj.download_text = ''; 
                        
                    //     })
                    //     .catch(function (error) {
                    //         currentObj.output = error;
                    //         currentObj.download_loader = false;
                    //         currentObj.download_text = '';
                    //         currentObj.showoverlay_h = false;
                    //     });

                    currentObj.download_text = 'We are processing your download and this may take some time based on the number of files you are downloading. Do not close this window until the download begins.';                    
                    
                    axios.post(this.$api_url_front+'/templates/downloadsingletemplate', formData, config)
                    .then(function (response) {
                        
                        currentObj.showoverlay_h = false;
                        var fname=response.data.file_name;
                        if(response.data.download_file_name)
                            var download_f_name =   response.data.download_file_name;
                        else
                            var download_f_name =   fname; 
                        if(download_f_name){  
                            // window.location.href = currentObj.$api_url_front+'/templates/downloadzip?file_name='+fname+'&download_file_name='+download_f_name+'&modification_flag='+modification_flag;  
                            axios.post(currentObj.$api_url + '/front/templates/downloadzip', {
                                    file_name: fname,
                                    download_file_name: download_f_name,
                                    modification_flag: modification_flag,
                                }, {
                                    responseType: 'blob',
                                })
                                .then(function (dlResponse) {
                                    if (dlResponse.data.type === 'application/json') {
                                        let file = new Blob([dlResponse.data], { type: 'application/json' });
                                        Promise.resolve(file.text()).then(function (value) {
                                            let err_obj = JSON.parse(value);
                                            currentObj.$bvToast.toast(err_obj.error_msg, { title: 'Error', variant: 'danger', solid: true });
                                        });
                                    } else {
                                        currentObj.global_download_file_content(dlResponse);
                                    }
                                    currentObj.download_loader = false;
                                    currentObj.download_text = '';
                                })
                                .catch(function (error) {
                                    currentObj.output = error;
                                    currentObj.download_loader = false;
                                    currentObj.download_text = '';
                                });  
                        
                            //console.log(currentObj.$api_url+'/templates/downloadzip?file_name='+fname+'&download_file_name='+download_f_name+'&modification_flag='+modification_flag);
                        }
                        
                        if(response.data.errors)
                        {
                            
                            var errors = response.data.errors;
                            errors.replace("<br>", "</br>");
                            currentObj.$bvToast.toast(response.data.errors, {title: 'Error!',variant: 'danger',solid: true, toaster: "toaster: b-toaster-top-right"});

                        }
                        
                        currentObj.download_loader = false;  
                        currentObj.download_text = ''; 
                        
                        })
                        .catch(function (error) {
                            currentObj.output = error;
                            currentObj.download_loader = false;
                            currentObj.download_text = '';
                            currentObj.showoverlay_h = false;
                        });

                    // End: Rejwan: 23-06-2026
                }
                    
                                             
            },
            onSubmit(e)
            {  
                if(!this.checkNet()) return false;
               
                this.$validator.validateAll().then(result => { 
                    if (!result) {
                        return; 
                    }  
                    e.preventDefault();  
                    // let mod_flag = 16; // Rejwan: 23-06-2026
                    let mod_flag = 19; // Rejwan: 23-06-2026
                    this.downloadCertificate( this.employee_id,this.profit_distribution_type,0,0);


                    // // if(this.fdata.profit_waiver_from != null)
                    // // {   
                    // //     const minWaiverDate = new Date(this.fdata.profit_waiver_from);
                    // // }
                    
                    // let currentObj = this;
                    // currentObj.errormsg = '';
                    // let formData = new FormData();
                    // formData.append('employee_id', this.employee_info.employee_id);   
                    // formData.append('type', this.profit_distribution_type);  
                    // formData.append('from_year', this.profit_specific_range_from_year); 
                    // formData.append('from_month', this.profit_specific_range_from_month); 
                    // formData.append('to_year', this.profit_specific_range_to_year); 
                    // formData.append('to_month', this.profit_specific_range_to_month); 
                    // formData.append('fiscal_year', this.profit_fiscal_year); 

                    // this.showoverlay = true;
                
                    // axios.post(this.$api_url+'/pf/report/statement', formData)
                    //     .then(function (response)
                    //     {
                           
                    //         this.$bvToast.toast("Saved!", {
                    //                 title: `Success`,
                    //                 variant: 'success',
                    //                 solid: true
                    //             });
                            

                    //         if(response.data.file_name){

                    //         this.download_file_name = response.data.download_name;
                                
                    //         this.download_file(response.data.file_name,this.download_file_name+'.pdf');
                    //         }
                    //         this.showoverlay = false;
                    //         this.$emit('childToParent');
                    //     }.bind(this))
                    //     .catch(function (error)
                    //     {          
                    //         currentObj.showoverlay = false;
                    //         currentObj.serverError(error);
                    //         currentObj.errormsg = error.response.data.errors;                                    
                    //         for (var data in currentObj.errormsg)
                    //         {
                    //             var msg = currentObj.errormsg[data];
                    //             currentObj.$bvToast.toast(msg, {
                    //                 title: `Error`,
                    //                 variant: 'danger',
                    //                 solid: true
                    //             });
                    //             currentObj.$validator.reset();
                    //         }
                    //     });
                });
            },
            getEmployeeActiveYearlist:function(employee_id)
            {        
                
                if(!this.checkNet()) return false;

                    this.resetForm();
                   
                    let formData = new FormData();
                
                    formData.append('employee_id', employee_id);

                    //currentObj.showoverlay = true;
                    
                    // axios.post(this.$api_url + '/pf/employee/active-year-list', formData) // Start: Rejwan: 09-02-2026 Front Routes
                    axios.post(this.$api_url_front + '/self/pf/employee/active-year-list', formData) // Start: Rejwan: 17-02-2026 Front Routes
                    .then(function (response) 
                    {
                        this.respData = response.data;
                        
                        if(this.respData.fiscal_year.length > 0) 
                        {
                            this.f_y = this.respData.fiscal_year;
                            this.years = this.respData.year;
                        }
                        else
                        {
                            this.statememt_available = false;
                        }
                        this.showoverlay = false;
                        
                    }.bind(this)).catch(function (error){alert(error)});

               
               
            },   
           
        }, 
        created: function(){
          
            this.getPFSettings();
            this.getEmployeeActiveYearlist(this.employee_id);
        }
    } 
</script>
<style>
.b-overlay-wrap.trz_overlay .b-overlay {
	height: 100%;
} 
</style>
<!-- End: Rejwan: 09-02-2026 Front Routes -->
